import _ from "lodash";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

const TTSVoiceSelector = (props) => {
  // const { TTSVoices } = props.envStore;
  const { name = "voice", setValue, source = [] } = props;
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setOptions(
      _.map(source, (value) => {
        return { value: value.id, label: value.name };
      }),
    );
  }, [source]);

  const onChangeHandler = (selectedOptions) => {
    const value = selectedOptions.value;
    setValue({ [name]: value });
  };

  return (
    <Select
      isMulti={false}
      name={name}
      value={props.value ? { value: props.value, label: props.value } : null}
      options={options}
      onChange={onChangeHandler}
    />
  );
};

const mapStateToProps = (state) => ({
  envStore: state.api.env,
});

export default connect(mapStateToProps, {})(TTSVoiceSelector);
